export const VIEW_SETUP_FEATURE_FLAG = "FLASH_OS_SETUP_VIEW";
